import { timeoutSignal } from "@jkast90/kast-common/fetch";
import { UPLOAD_TIMEOUT_MS } from "./api";

/**
 * The Cache-Control every gallery and shop photo is stored with. The API gives
 * each upload a fresh `<prefix>/<uuid>.<ext>` key and never overwrites one
 * (deploy caching rule 6), but a photo can be deleted (a moderation takedown),
 * so it is not `immutable`: CloudFront keeps it a year (s-maxage) and the API
 * purges it there on delete, while browsers, which no purge reaches, keep it a
 * day. The presigned PUT signs this exact value (UPLOAD_CACHE_CONTROL in
 * api/src/services/s3.rs): send anything else and
 * S3 rejects the signature.
 */
export const UPLOAD_CACHE_CONTROL = "public, max-age=86400, s-maxage=31536000";

/** PUT a file to a presigned upload URL with the headers the URL signs. */
export function putToPresignedUrl(uploadUrl: string, file: File): Promise<Response> {
  return fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type, "Cache-Control": UPLOAD_CACHE_CONTROL },
    body: file,
    signal: timeoutSignal(UPLOAD_TIMEOUT_MS),
  });
}
